import React from "react";
import "./QuestionCard.css";
import MultipleQuestion from "./MultipleQuestion";
import Select from "react-select";


const QuestionCard = ({
    question,
    index,
    onChange,
    onDelete
}) => {


    // ?  CONFIGURATION ON CHANGU

    const handleChange = (
        field,
        value
    ) => {
        onChange(question?.id, field, value);
    };


    const getQuestionTypeLabel = (
    ) => {
        switch (question?.type) {

            case "open":
                return "PREGUNTA ABIERTA";

            case "time":
                return "PREGUNTA DE TIEMPO";

            case "complex":
                return "PREGUNTA CERRADA";

            case "multiple":
                return "OPCIÓN MÚLTIPLE";

            default:
                return "PREGUNTA";
        }
    };



    return (
        <div
            className={`survey-sampling-question-card survey-sampling-question-card-${question.type}`}
        >

            <div className="survey-sampling-question-card-header">

                <div className="survey-sampling-question-card-information">

                    <div className="survey-sampling-question-card-number">
                        {index + 1}
                    </div>

                    <div
                        className={`survey-sampling-question-card-type survey-sampling-question-card-type-${question.type}`}
                    >
                        {getQuestionTypeLabel()}
                    </div>

                </div>

                {
                    // * QUESTION
                }

                <div className="survey-sampling-question-card-actions">


                    {/* SEXO */}
                    <div className="survey-sampling-question-gender-control">

                        <i className="fa fa-venus-mars"></i>

                        <Select
                            className="survey-sampling-gender-select"
                            classNamePrefix="survey-sampling-gender-select"

                            value={
                                [
                                    {
                                        value: "both",
                                        label: "Ambos",
                                        icon: "fa-venus-mars"
                                    },
                                    {
                                        value: "female",
                                        label: "Mujer",
                                        icon: "fa-venus"
                                    },
                                    {
                                        value: "male",
                                        label: "Hombre",
                                        icon: "fa-mars"
                                    }
                                ].find(
                                    (item) =>
                                        item.value === (question?.gender || "both")
                                )
                            }

                            options={[
                                {
                                    value: "both",
                                    label: "Ambos",
                                    icon: "fa-venus-mars"
                                },
                                {
                                    value: "female",
                                    label: "Mujer",
                                    icon: "fa-venus"
                                },
                                {
                                    value: "male",
                                    label: "Hombre",
                                    icon: "fa-mars"
                                }
                            ]}

                            onChange={(option) =>
                                handleChange(
                                    "gender",
                                    option?.value || "both"
                                )
                            }

                            isSearchable={false}
                            isClearable={false}
                            menuPlacement="auto"
                        />

                    </div>


                    <label
                        className="survey-sampling-question-required-control"
                        htmlFor={`question-required-${question?.id}`}
                    >
                        <input
                            id={`question-required-${question?.id}`}
                            type="checkbox"
                            checked={question?.required === true}
                            onChange={(event) =>
                                handleChange(
                                    "required",
                                    event?.target?.checked
                                )
                            }
                        />

                        <span className="survey-sampling-question-required-checkbox">
                            <i className="fa fa-check"></i>
                        </span>

                        <span className="survey-sampling-question-required-label">
                            Requerido
                        </span>

                    </label>

                    <button
                        type="button"
                        className="survey-sampling-question-delete-button"
                        title="Eliminar pregunta"
                        onClick={() => onDelete(question?.id)}
                    >
                        <i className="fa fa-trash-o"></i>
                    </button>

                </div>

            </div>

            <div className="survey-sampling-question-card-body">

                {question?.type === "open" && (
                    <OpenQuestion
                        question={question}
                        onChange={handleChange}
                    />
                )}

                {question?.type === "time" && (
                    <TimeQuestion
                        question={question}
                        onChange={handleChange}
                    />
                )}

                {question?.type === "complex" && (
                    <ClosedQuestion
                        question={question}
                        onChange={handleChange}
                    />
                )}

                {question?.type === "multiple" && (
                    <MultipleQuestion
                        question={question}
                        onChange={handleChange}
                    />
                )}

            </div>
        </div>
    );
};



const OpenQuestion = (
    {
        question,
        onChange
    }
) => {

    return (
        <>
            <div className="survey-sampling-question-field">

                <input
                    type="text"
                    className="survey-sampling-question-input"
                    value={question?.question || ""}
                    placeholder="Escriba la pregunta"
                    onChange={(event) =>
                        onChange(
                            "question",
                            event?.target?.value
                        )
                    }
                />

            </div>

            <div className="survey-sampling-question-field">

                <label className="survey-sampling-question-label">
                    Texto de ayuda para el paciente (placeholder):
                </label>

                <input
                    type="text"
                    className="survey-sampling-question-help-input"
                    value={question?.placeholder || ""}
                    placeholder="Ej. Alergia a la penicilina, hipertensión, asma..."
                    onChange={(event) =>
                        onChange(
                            "placeholder",
                            event?.target?.value
                        )
                    }
                />
            </div>
        </>
    );
};




const TimeQuestion = (
    {
        question,
        onChange
    }
) => {

    return (
        <>
            <div className="survey-sampling-question-field">
                <input
                    type="text"
                    className="survey-sampling-question-input"
                    value={question?.question || ""}
                    placeholder="Ej. ¿A qué hora fue su último alimento sólido o líquido?"
                    onChange={(event) =>
                        onChange(
                            "question",
                            event?.target?.value
                        )
                    }
                />
            </div>

            <div className="survey-sampling-time-information">

                <div className="survey-sampling-time-information-icon">
                    <i className="fa fa-clock-o"></i>
                </div>

                <div className="survey-sampling-time-information-content">

                    <p>
                        <strong>
                            Métrica de Tiempo Activa:
                        </strong>

                        {" "}Este componente calcula automáticamente la
                        diferencia en horas contra el tiempo del sistema
                        para evaluar parámetros médicos, por ejemplo, ayuno.
                    </p>

                </div>

            </div>

        </>
    );
};


// * TYPE QUESTION 
const ClosedQuestion = (
    {
        question,
        onChange
    }
) => {

    const options = Array.isArray(question?.options)
        ? question.options
        : [];

    const updateOptions = (newOptions) => {
        onChange("options", newOptions);
    };

    const handleOptionChange = (
        optionIndex,
        field,
        value
    ) => {

        const newOptions = options.map((option, index) => {

            if (index !== optionIndex) {
                return option;
            }

            return {
                ...option,
                [field]: value
            };
        });

        updateOptions(newOptions);
    };

    const handleSubQuestionChange = (
        optionIndex,
        field,
        value
    ) => {

        const newOptions = options.map((option, index) => {

            if (index !== optionIndex) {
                return option;
            }

            return {
                ...option,
                subQuestion: {
                    ...(option?.subQuestion || {
                        type: "open",
                        question: "",
                        placeholder: ""
                    }),
                    [field]: value
                }
            };
        });

        updateOptions(newOptions);
    };

    // * OPTIONS MULTIPLES

    const handleSubMultipleOptionChange = (
        optionIndex,
        subOptionIndex,
        value
    ) => {
        const currentSubOptions =
            options[optionIndex]?.subQuestion?.options || [];

        const newSubOptions = currentSubOptions.map(
            (subOption, index) =>
                index === subOptionIndex
                    ? {
                        ...subOption,
                        label: value
                    }
                    : subOption
        );

        handleSubQuestionChange(
            optionIndex,
            "options",
            newSubOptions
        );
    };



    // * NEW OPTION MULTIPLE


    const handleAddSubMultipleOption = (
        optionIndex
    ) => {

        const currentSubOptions = options[optionIndex]?.subQuestion?.options || [];

        const newSubOption = {
            id: `${options[optionIndex].id}-sub-option-${Date.now()}`,
            label: "",
            value: ""
        };

        handleSubQuestionChange(
            optionIndex,
            "options",
            [
                ...currentSubOptions,
                newSubOption
            ]
        );
    };

    // * DELETE OPTION MULTIPLE
    const handleDeleteSubMultipleOption = (
        optionIndex,
        subOptionIndex
    ) => {
        const currentSubOptions =
            options[optionIndex]?.subQuestion?.options || [];

        if (currentSubOptions.length <= 2) {
            return;
        }

        const newSubOptions = currentSubOptions.filter(
            (_, index) => index !== subOptionIndex
        );

        handleSubQuestionChange(
            optionIndex,
            "options",
            newSubOptions
        );
    };



    // * MULTIPLE QUESTION
    const handleSubQuestionTypeChange = (
        optionIndex,
        newType
    ) => {
        const newOptions = options.map((option, index) => {
            if (index !== optionIndex) {
                return option;
            }

            let newSubQuestion = {
                type: newType,
                question: "",
                placeholder: ""
            };

            if (newType === "time") {
                newSubQuestion = {
                    type: "time",
                    question: option?.subQuestion?.question || "",
                    timeFormat: "hours_minutes" // * ----------
                };
            }

            if (newType === "open") {
                newSubQuestion = {
                    type: "open",
                    question: option?.subQuestion?.question || "",
                    placeholder: option?.subQuestion?.placeholder || ""
                };
            }

            if (newType === "multiple") {
                newSubQuestion = {
                    type: "multiple",
                    question: option?.subQuestion?.question || "",
                    selectionMode: "single",
                    options: []
                };
            }

            return {
                ...option,
                subQuestion: newSubQuestion
            };
        });

        updateOptions(newOptions);
    };





    // * methods 
    const handleToggleSubQuestion = (
        optionIndex,
        checked
    ) => {

        const newOptions = options.map((option, index) => {

            if (index !== optionIndex) {
                return option;
            }

            return {
                ...option,
                hasSubQuestion: checked,

                subQuestion: checked
                    ? (
                        option?.subQuestion || {
                            type: "open",
                            question: "",
                            placeholder: ""
                        }
                    )
                    : null
            };
        });

        updateOptions(newOptions);
    };


    // * ADD OPTION

    const handleAddOption = () => {

        const newOption = {
            id: `${question.id}-option-${Date.now()}`,
            label: "",
            value: "",
            hasSubQuestion: false,
            subQuestion: null
        };

        updateOptions([
            ...options,
            newOption
        ]);
    };

    const handleDeleteOption = (
        optionIndex
    ) => {

        const newOptions = options.filter(
            (_, index) => index !== optionIndex
        );

        updateOptions(newOptions);
    };

    return (
        <>
            {
                // ! QUESTION
            }
            <div className="survey-sampling-question-field">

                <input
                    type="text"
                    className="survey-sampling-question-input"
                    value={question?.question || ""}
                    placeholder="Ej. ¿Toma algún medicamento?"
                    onChange={(event) =>
                        onChange(
                            "question",
                            event?.target?.value
                        )
                    }
                />

            </div>

            {
                // ! OPTIONS QUESTION 
            }
            <div className="survey-sampling-closed-options-container">

                <div className="survey-sampling-closed-options-header">

                    <div>
                        <h4 className="survey-sampling-closed-options-title">
                            Opciones de respuesta
                        </h4>

                        <p className="survey-sampling-closed-options-description">
                            Configure el botón y seleccione cuál mostrará una subpregunta.


                        </p>
                    </div>

                    <button
                        type="button"
                        className="survey-sampling-add-option-button"
                        onClick={handleAddOption}
                    >
                        <i className="fa fa-plus"></i>
                        Agregar opción
                    </button>

                </div>

                <div className="survey-sampling-closed-options-list">

                    {options.map((option, optionIndex) => (

                        <div
                            key={option?.id}
                            className="survey-sampling-closed-option-card"
                        >

                            <div className="survey-sampling-closed-option-main">

                                <div className="survey-sampling-closed-option-number">
                                    {optionIndex + 1}
                                </div>

                                <div className="survey-sampling-closed-option-field">

                                    <label>
                                        Texto del botón
                                    </label>

                                    <input
                                        type="text"
                                        value={option?.label || ""}
                                        placeholder="Ej. Sí"
                                        onChange={(event) =>
                                            handleOptionChange(
                                                optionIndex,
                                                "label",
                                                event?.target?.value
                                            )
                                        }
                                    />

                                </div>

                                <label className="survey-sampling-closed-option-checkbox">

                                    <input
                                        type="checkbox"
                                        checked={
                                            option?.hasSubQuestion === true
                                        }
                                        onChange={(event) =>
                                            handleToggleSubQuestion(
                                                optionIndex,
                                                event?.target?.checked
                                            )
                                        }
                                    />
                                    <span>
                                        Mostrar subpregunta
                                    </span>
                                </label>

                                <button
                                    type="button"
                                    className="survey-sampling-delete-option-button"
                                    // disabled={options.length <= 2}
                                    onClick={() =>
                                        handleDeleteOption(optionIndex)
                                    }
                                    title={
                                        options.length <= 2
                                            ? "Debe conservar al menos dos opciones"
                                            : "Eliminar opción"
                                    }
                                >
                                    <i className="fa fa-trash"></i>
                                </button>

                            </div>
                            {
                                // * SUB PREGUNTA
                            }
                            {option?.hasSubQuestion === true && (

                                <div className="survey-sampling-conditional-container">

                                    <div className="survey-sampling-conditional-header">

                                        <div className="survey-sampling-conditional-title">

                                            <i className="fa fa-clone"></i>

                                            <span>
                                                Subnivel de pregunta
                                            </span>

                                        </div>

                                        <div className="survey-sampling-conditional-trigger">
                                            <strong>
                                                {option?.label || "Esta opción"}
                                            </strong>

                                        </div>

                                    </div>

                                    <div className="survey-sampling-subquestion-container">

                                        <div className="survey-sampling-subquestion-header">

                                            <span className="survey-sampling-subquestion-title">
                                                SUBPREGUNTA ANIDADA
                                            </span>

                                            <div className="survey-sampling-subquestion-type">

                                                <label>
                                                    Tipo:
                                                </label>

                                                <select
                                                    value={
                                                        option?.subQuestion?.type ||
                                                        "open"
                                                    }
                                                    onChange={(event) =>
                                                        handleSubQuestionTypeChange(
                                                            optionIndex,
                                                            event?.target?.value
                                                        )
                                                    }
                                                >
                                                    <option value="open">
                                                        Abierta
                                                    </option>

                                                    {/*       <option value="time">
                                                        Tiempo
                                                    </option> */   }

                                                    <option value="multiple">
                                                        Opción múltiple
                                                    </option>
                                                </select>

                                            </div>

                                        </div>



                                        <div className="survey-sampling-subquestion-fields">
                                            {
                                                // * SUB PREGUNTA
                                            }
                                            <input
                                                type="text"
                                                className="survey-sampling-subquestion-input"
                                                value={option?.subQuestion?.question || ""}
                                                placeholder="Escriba la subpregunta"
                                                onChange={(event) =>
                                                    handleSubQuestionChange(
                                                        optionIndex,
                                                        "question",
                                                        event?.target?.value
                                                    )
                                                }
                                            />
                                            {
                                                // * SUB PREGUNTA 
                                            }

                                            {option.subQuestion?.type === "open" && (
                                                <input
                                                    type="text"
                                                    className="survey-sampling-subquestion-placeholder"
                                                    value={option.subQuestion?.placeholder || ""}
                                                    placeholder="Ej. Escriba el nombre del medicamento"
                                                    onChange={(event) =>
                                                        handleSubQuestionChange(
                                                            optionIndex,
                                                            "placeholder",
                                                            event.target.value
                                                        )
                                                    }
                                                />
                                            )}

                                            {
                                                // * TIME
                                            }

                                            {option.subQuestion?.type === "time" && (
                                                <div className="survey-sampling-subquestion-time-config">

                                                    <div className="survey-sampling-subquestion-time-field">

                                                        <label>
                                                            Formato de captura
                                                        </label>

                                                        <select
                                                            value={
                                                                option.subQuestion?.timeFormat ||
                                                                "hours_minutes"
                                                            }
                                                            onChange={(event) =>
                                                                handleSubQuestionChange(
                                                                    optionIndex,
                                                                    "timeFormat",
                                                                    event.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="hours_minutes">
                                                                Horas y minutos
                                                            </option>

                                                            <option value="hours_minutes_seconds">
                                                                Horas, minutos y segundos
                                                            </option>
                                                        </select>

                                                    </div>

                                                    <div className="survey-sampling-subquestion-time-preview">

                                                        <span>
                                                            Vista del campo
                                                        </span>

                                                        <input
                                                            type="time"
                                                            step={
                                                                option.subQuestion?.timeFormat ===
                                                                    "hours_minutes_seconds"
                                                                    ? "1"
                                                                    : "60"
                                                            }
                                                            disabled
                                                        />

                                                    </div>

                                                </div>
                                            )}


                                            {
                                                // * OPTION MULTIPLE
                                            }
                                            {option.subQuestion?.type === "multiple" && (
                                                <div className="survey-sampling-submultiple-container">

                                                    <div className="survey-sampling-submultiple-header">

                                                        <div className="survey-sampling-submultiple-mode">

                                                            <label>
                                                                Tipo de selección
                                                            </label>

                                                            <select
                                                                value={
                                                                    option?.subQuestion?.allowMultiple
                                                                        ? "multiple"
                                                                        : "single"
                                                                }
                                                                onChange={(event) =>
                                                                    handleSubQuestionChange(
                                                                        optionIndex,
                                                                        "allowMultiple",
                                                                        event.target.value === "multiple"
                                                                    )
                                                                }
                                                            >
                                                                <option value="single">
                                                                    Solo una opción
                                                                </option>

                                                                <option value="multiple">
                                                                    Varias opciones
                                                                </option>
                                                            </select>

                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="survey-sampling-submultiple-add-button"
                                                            onClick={() =>
                                                                handleAddSubMultipleOption(optionIndex)
                                                            }
                                                        >
                                                            <i className="fa fa-plus"></i>

                                                            Agregar opción
                                                        </button>

                                                    </div>

                                                    <div className="survey-sampling-submultiple-options">

                                                        {(option.subQuestion?.options || []).map(
                                                            (subOption, subOptionIndex) => (
                                                                <div
                                                                    key={subOption?.id}
                                                                    className="survey-sampling-submultiple-option"
                                                                >

                                                                    <div className="survey-sampling-submultiple-letter">
                                                                        {String.fromCharCode(
                                                                            65 + subOptionIndex
                                                                        )}
                                                                    </div>

                                                                    <input
                                                                        type="text"
                                                                        value={subOption?.label || ""}
                                                                        placeholder={`Opción ${String.fromCharCode(
                                                                            65 + subOptionIndex
                                                                        )}`}
                                                                        onChange={(event) =>
                                                                            handleSubMultipleOptionChange(
                                                                                optionIndex,
                                                                                subOptionIndex,
                                                                                event?.target?.value
                                                                            )
                                                                        }
                                                                    />

                                                                    <button
                                                                        type="button"
                                                                        className="survey-sampling-submultiple-delete-button"
                                                                        disabled={
                                                                            (
                                                                                option?.subQuestion?.options ||
                                                                                []
                                                                            ).length <= 2
                                                                        }
                                                                        onClick={() =>
                                                                            handleDeleteSubMultipleOption(
                                                                                optionIndex,
                                                                                subOptionIndex
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </button>

                                                                </div>
                                                            )
                                                        )}

                                                    </div>

                                                </div>
                                            )}

                                        </div>

                                    </div>

                                </div>

                            )}

                        </div>

                    ))}

                </div>

            </div>
        </>
    );
};




export default QuestionCard;